<script>
import FButton from '@justeat/f-button'

export default {
  mixins: [FButton]
}
</script>

<style scoped src="@justeat/f-button/dist/f-button.css"></style>
